import { RootState } from "app.store";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SetCart } from "states/cart/cart.action";
import { applyCouponCartApi, applyCouponShoppingCartApi, removeCouponCartApi, removeCouponShoppingCartApi } from "states/cart/cart.api";
import { ApplyCouponModel, WebsiteApplyCouponShoppingCartModel, WebsiteRemoveCouponShoppingCartModel } from "states/cart/cart.models";
import { globalValueGetCart, globalValueSetLoading, globalValueSetToast, globalValueShowConfirmModal } from "states/global-value/global-value.action";
import { ConfirmModel, ToastModel, ToastType } from "states/global-value/global-value.models";

interface CouponProps {
  coupon: string;
}
export const CouponComponent = (props: CouponProps) => {
  const dispatch = useDispatch();
  const { coupon } = props;
  const isGetCart = useSelector((state: RootState) => state.globalValue.isGetCart);
  const isAuthentication = useSelector((state: RootState) => state.account.isAuthentication);
  const [ couponCode, setCouponCode] = useState<string>("");
  const _handleApplyCoupon = async () => {
    if(couponCode === "" || couponCode === null){
      dispatch(
        globalValueSetToast({
          message: "Vui lòng nhập mã giảm giá",
          type: ToastType.error,
        } as ToastModel)
      );
      return false;
    }
    dispatch(globalValueSetLoading(true));
    try {
     if(isAuthentication){
      await applyCouponCartApi({
        couponCode: couponCode
       } as ApplyCouponModel);
     }else{
       await applyCouponShoppingCartApi({ couponCode : couponCode} as WebsiteApplyCouponShoppingCartModel)
     }
      dispatch(globalValueGetCart(!isGetCart));
      dispatch(
        globalValueSetToast({
          message: "Áp dụng mã giảm giá thành công",
          type: ToastType.success,
        } as ToastModel)
      );
      dispatch(globalValueSetLoading(false));
    } catch (error) {
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleRemoveCoupon = async () => {
    dispatch(globalValueSetLoading(true));
    try {
      if(isAuthentication){
        await removeCouponCartApi();
      }else{
        await removeCouponShoppingCartApi({} as WebsiteRemoveCouponShoppingCartModel);
      }
      setCouponCode("");
      dispatch(globalValueGetCart(!isGetCart));
      dispatch(globalValueSetLoading(false));
    } catch (error) {
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  useEffect(() => {
    setCouponCode(coupon ?? "");
  }, [coupon]);
  return (
    <div className="coupon-container">
      <div className="text-bold name-container">Mã giảm giá / quà tặng</div>
      <div className="input-container">
        {coupon === null || coupon === "" ? (
          <React.Fragment>
            <input
              type="text"
              value={couponCode}
              className="form-control"
              placeholder="Mã giảm giá"
              onChange={(ev) => {
                setCouponCode(ev.target.value);
              }}
            />
            <button
              onClick={(ev) => {
                ev.preventDefault();
                _handleApplyCoupon();
              }}
              className="btn btn-primary"
            >
              Áp dụng
            </button>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <input
              type="text"
              value={couponCode}
              disabled={true}
              className="form-control"
              placeholder="Mã giảm giá"
            />
            <button
              onClick={() => {
                dispatch(globalValueShowConfirmModal({ 
                  isModal: true,
                  message:"Bạn có chắn chắc muốn hủy áp dụng mã giảm giá không?",
                  onYes: async () => { 
                    await _handleRemoveCoupon();
                    dispatch(globalValueShowConfirmModal({isModal: false}));
                  },
                  onCancel: () => { 
                    dispatch(globalValueShowConfirmModal({isModal: false}));
                  }
                } as ConfirmModel));
              }}
              className="btn btn-danger"
            >
              Hủy
            </button>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};
